import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { xAuthToken } from '@core/services';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem(xAuthToken);

    if (token) {
      request = request.clone({
        setHeaders: {
          'X-Auth-Token': token
        },
        withCredentials: true // Include cookies in cross-origin requests
      });
    } else {
      // Even without token, include credentials for cookie-based auth
      request = request.clone({
        withCredentials: true
      });
    }
    return next.handle(request);
  }
}
